export default __webpack_public_path__ + "static/media/airport_logo.75275c7f.png";